import './video.scss';

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';

class Video {
    constructor (element) {
        this.$videoModule = element;
        this.$videoSliderContainer = this.$videoModule.querySelector('[data-video="slider"]');
        this.slider = null;
        this.sliderActive = false;
    }

    initialize () {
        if (this.$videoSliderContainer) {
            this.initSlider();
        }
    }

    initSlider () {
        this.sliderActive = true;

        this.slider = new Swiper(this.$videoSliderContainer, {
            modules: [Navigation],
            slidesPerView: 'auto',
            speed: 500,
            autoHeight: false
        });
    }

    destroySlider () {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider = null;
            this.sliderActive = false;
        }
    }
}

export { Video };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $videos = $context.querySelectorAll('[data-video="root"]');

        for (let i = 0; i < $videos.length; i++) {
            const $video = new Video($videos[i]);
            $video.initialize();
        }
    }
});
